class Gift{
    constructor(name, imgUrl, description,price,tags){
        this.name=name;
        this.imgUrl = imgUrl;
        this.description = description;
        this.price = price;
        this.tags = tags
    }
}
export default Gift